import React, { useEffect, useRef } from 'react';
import { normalizeRichTextLinksInContainer } from '@/utils/normalizeRichTextLinks';

const RichTextHtmlViewer = ({
  html,
  className
}: {
  html?: string | null;
  className?: string;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    normalizeRichTextLinksInContainer(container);
  }, [html]);

  if (!html) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RichTextHtmlViewer;
